interface CategoryCardProps {
  name: string;
  description: string;
  link: string;
  tag: string;
  image: string;
}

export default function CategoryCard({ name, description, link, tag, image }: CategoryCardProps) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener nofollow"
      className="group relative block overflow-hidden rounded-2xl aspect-[4/3] cursor-pointer"
    >
      <img
        src={image}
        alt={name + " pandabuy spreadsheet finds"}
        title={name + " - PandaBuy Spreadsheet Collection"}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
      {tag && (
        <span className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-white whitespace-nowrap">
          {tag}
        </span>
      )}
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <h3 className="text-white text-lg font-semibold leading-tight">{name}</h3>
        <p className="text-white/75 text-sm mt-1">{description}</p>
      </div>
    </a>
  );
}